import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const ClaimTypeCell = ({ claim, claimTypes, setClaimTypes }) => {
  const { t } = useTranslation();

  const options = [
    { value: "B2B", label: <span>🏢 {t("B2B")}</span> },
    { value: "B2C", label: <span>👤 {t("B2C")}</span> },
  ];

  const handleChange = (selectedOption) => {
    if (!claim?._id) return;
    setClaimTypes((prev) => ({
      ...prev,
      [claim._id]: selectedOption?.value || "",
    }));
  };

  return (
    <td>
      <Select
        options={options}
        value={options.find((o) => o.value === claimTypes[claim._id]) || null}
        onChange={handleChange}
        isDisabled={claim.status !== "Waiting for Admin Action"}
        placeholder={t("invoiceType.select")}
        classNamePrefix="react-select"
        menuPortalTarget={document.body}

        styles={{
          control: (base, state) => ({
            ...base,
            minHeight: "32px",
            minWidth: "125px",
            fontSize: "14px",
            borderRadius: "8px",
            boxShadow: state.isFocused ? "0 0 0 1px #4f46e5" : base.boxShadow,
            borderColor: state.isFocused ? "#4f46e5" : base.borderColor,
            "&:hover": { borderColor: "#4f46e5" },
          }),
          option: (base, state) => ({
            ...base,
            fontSize: "14px",
            padding: "6px 12px",
            backgroundColor: state.isSelected
              ? "#4f46e5"
              : state.isFocused
                ? "#e0e7ff"
                : "white",
            color: state.isSelected ? "white" : "black",
          }),
          singleValue: (base) => ({
            ...base,
            fontSize: "14px",
            color: "#111827",
          }),
          placeholder: (base) => ({
            ...base,
            fontSize: "14px",
            color: "#6b7280",
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />
    </td>
  );
};

export default ClaimTypeCell;
